/**
 * Contact Form 7: Cloudflare Turnstile progressive disclosure & interaction trigger.
 *
 * Keeps Turnstile security widgets completely hidden until a user actually
 * begins interacting with a form (typing, focusing, selecting options).
 * This eliminates visual clutter for visitors merely browsing content
 * (e.g. viewing sponsors, reading pages) while ensuring the challenge token
 * is seamlessly acquired by the time the visitor submits.
 */

export default function initCf7Turnstile() {
    const initForm = (form) => {
        if (!form || form.dataset.turnstileInitialized) {
            return;
        }
        form.dataset.turnstileInitialized = 'true';

        const activate = () => {
            if (!form.classList.contains('is-interacting')) {
                form.classList.add('is-interacting');
            }
        };

        // Check if any text/email/tel/textarea field already has a value (e.g. browser autofill or history restore)
        const textInputs = form.querySelectorAll(
            'input[type="text"], input[type="email"], input[type="tel"], input[type="url"], input[type="number"], textarea'
        );
        let hasValue = false;
        textInputs.forEach((input) => {
            if (input.value && input.value.trim().length > 0) {
                hasValue = true;
            }
        });

        if (hasValue) {
            activate();
        }

        // Active interaction event listeners: typing or changing field values
        form.addEventListener('input', activate, { passive: true });
        form.addEventListener('change', activate, { passive: true });
        form.addEventListener('keydown', activate, { passive: true });

        // Guarantee active state upon any submit attempt
        form.addEventListener('submit', activate);
        form.addEventListener('wpcf7submit', activate);
    };

    document.querySelectorAll('.wpcf7-form').forEach(initForm);

    // Observe dynamic insertions (e.g. booking modal, AJAX views)
    if (typeof MutationObserver !== 'undefined' && document.body) {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === 1) {
                        if (node.classList?.contains('wpcf7-form')) {
                            initForm(node);
                        } else if (node.querySelectorAll) {
                            node.querySelectorAll('.wpcf7-form').forEach(initForm);
                        }
                    }
                });
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }
}
